import React from 'react';
import { StyleProp, TextProps, TextStyle, TouchableOpacity, TouchableOpacityProps, ViewStyle } from 'react-native';

import { useColor } from '@/hooks/useColor';

import DotsLoader from '../DotsLoader';
import Text, { TextProps as CustomTextProps } from '../Text';

const buttonStyles: StyleProp<ViewStyle> = {
  minWidth: 10,
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  height: 44,
  borderRadius: 10
};

const textStyles: StyleProp<TextStyle> = {
  fontSize: 16
};

interface BrandedButtonProps extends TouchableOpacityProps {
  children: React.ReactNode;
  loading?: boolean;
  loadingSize?: number;
  disabled?: boolean;
  textStyles?: StyleProp<TextStyle>;
  textProps?: TextProps;
  backGroundColor?: string;
  disabledBackGroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
  fontWeight?: CustomTextProps['fontWeight'];
}

const BrandedButton = (props: BrandedButtonProps) => {
  const colors = useColor();
  const textColor = props.disabled ? colors.buttonText : colors.buttonText;
  const backgroundColor = props.disabled
    ? (props.disabledBackGroundColor ?? colors.neutralButton)
    : (props.backGroundColor ?? colors.primary);
  const borderColor = props.disabled ? colors.neutralButton : (props.borderColor ?? colors.primary);
  const loadingSize = props.loadingSize ?? 5;
  const { fontWeight = '700' } = props;

  return (
    <TouchableOpacity
      {...props}
      disabled={props.disabled || props.loading}
      style={[
        buttonStyles,
        {
          backgroundColor: backgroundColor,
          borderColor: borderColor,
          borderWidth: props.borderWidth ?? undefined
        },
        props.style
      ]}>
      {props.loading ? (
        <DotsLoader size={loadingSize} color={colors.buttonText} />
      ) : (
        <Text {...props.textProps} style={[textStyles, { color: textColor }, props.textStyles]} fontWeight={fontWeight}>
          {props.children}
        </Text>
      )}
    </TouchableOpacity>
  );
};

export default BrandedButton;
